export default "__VITE_ASSET__5ed4d486__"